// Remove leading non-digit characters (e.g. "ends in 6 mo" => "6 mo")
export function removeLeadingNonDigit(value: string): string {
  return value.replace(/^[^\d]*/g, '');
}
